module.exports = __webpack_public_path__ + "img/randabstand-DIN4141.76d9b833.jpg";